import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../admin/api"; // ✅ same as your BookDemo

function CandidateForm() {
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    experience: "",
    position: "",
    resume: null,
  });

  const handleChange = (e) => {
    if (e.target.name === "resume") {
      setFormData({ ...formData, resume: e.target.files[0] });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  // ✅ Submit with Axios + Toast
 const handleSubmit = async (e) => {
  e.preventDefault();
  
  // 🔹 Phone validation (10 digits only)
  const phoneRegex = /^[6-9]\d{9}$/;
  if (!phoneRegex.test(formData.phone)) {
    toast.error("❌ Enter valid 10-digit mobile number");
    return;
  }

  // 🔹 Email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(formData.email)) {
    toast.error("❌ Please enter valid email");
    return;
  }

  // 🔹 File validation
  if (!formData.resume) {
    toast.error("❌ Please upload resume");
    return;
  }

  // 🔹 File size validation (2MB)
  const maxSize = 2 * 1024 * 1024;
  if (formData.resume.size > maxSize) {
    toast.error("❌ File size must be less than 2MB");
    return;
  }

  const formDataToSend = new FormData();
  formDataToSend.append("name", formData.name);
  formDataToSend.append("email", formData.email);
  formDataToSend.append("phone", formData.phone);
  formDataToSend.append("experience", formData.experience);
  formDataToSend.append("position", formData.position);
  formDataToSend.append("resume", formData.resume);

  try {
    setLoading(true); // ✅ START LOADER

    const res = await api.post("/UiplusCandidates", formDataToSend, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (res.status === 200 || res.status === 201) {
      toast.success("Application Submitted Successfully");
      setIsSubmitted(true); // ✅ SHOW MESSAGE

      setFormData({
        name: "",
        email: "",
        phone: "",
        experience: "",
        position: "",
        resume: null,
      });

      document.querySelector('input[name="resume"]').value = "";
    } else {
      toast.error("❌ Failed to submit");
    }

  } catch (error) {
    console.error(error);
    toast.error("❌ Something went wrong");
  } finally {
    setLoading(false); // ✅ STOP LOADER
  }
};

  return (
    <div style={{ background: "#f4f6f9", minHeight: "100vh", padding: "50px 0" }}>
      <Container>
        <Row className="justify-content-center">
          <Col md={8}>
            <Card className="shadow-lg border-0 rounded-4">
              <Card.Body className="p-5">
                <h2 className="text-center mb-4 fw-bold">
                  Apply at Uiplus Technologies
                </h2>

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Enter your name"
                          value={formData.name || ""}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          placeholder="Enter your email"
                          value={formData.email || ""}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="phone"
                          maxLength={10}
                          value={formData.phone || ""}
                          onChange={(e) => {
                          // allow only numbers
                          const value = e.target.value.replace(/\D/g, "");
                          setFormData({ ...formData, phone: value });
                       }}
                          placeholder="Enter mobile number"
                          required
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Experience (Years)</Form.Label>
                        <Form.Control
                          type="text"
                          name="experience"
                          placeholder="Ex: 2 Years"
                          value={formData.experience}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Form.Group className="mb-3">
                    <Form.Label>Position Applying For</Form.Label>
                    <Form.Control
                      type="text"
                      name="position"
                      placeholder="React Developer / ASP.NET Developer"
                      value={formData.position}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label>Upload Resume</Form.Label>
                    <Form.Control
                      type="file"
                      name="resume"
                      accept=".pdf,.doc,.docx"
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>

                 
                    {isSubmitted && (
                     <div className="text-success text-center mt-3 mb-3">
                       ✅ Your application has been submitted successfully. <br />
                       Our HR team will review your resume and contact you shortly.
                     </div>
                    )}
                

                  <div className="text-center">
                    <Button variant="primary" type="submit" className="rounded-pill px-5 py-2" disabled={loading}
                    >
                     {loading ? "Submitting..." : "Submit Application"}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CandidateForm;
